export default $axios => ({ store }) => ({
    async all() {
        let [
            student,
            plagiarismOrders,
            freemiumOrders,
            proofreadingOrders,
            basketPlagiarismOrders,
            basketProofreadingOrders,
            discounts,
            invoices,
            aiProofreaderOrders,
            basketAiProofreaderOrders,
        ] = await Promise.all([
            store.$userRepository.get(),
            store.$plagiarismOrderRepository.list(),
            store.$plagiarismOrderRepository.listFreemium(),
            store.$proofreadingOrderRepository.list(),
            store.$basketRepository.listPlagiarismOrders(),
            store.$basketRepository.listProofreadingOrders(),
            store.$discountRepository.list(),
            store.$invoiceRepository.index(),
            store.$aiProofreaderOrderRepository.list(),
            store.$basketRepository.listAIProofreaderOrders(),
        ]);

        let allOrders = [...proofreadingOrders, ...plagiarismOrders];

        allOrders.forEach(order => {
            order.addInvoices(invoices.filter(i => i.orderReference === order.id));
        });

        let expertReviewOrders = [];
        expertReviewOrders = proofreadingOrders.filter(item => item.hasExpertReview);

        proofreadingOrders.unshift(...basketProofreadingOrders.filter(o => (o.isProcessingPayment || o.isUnpaidAndAfterOneMonthAgo) && !o.hasExpertReview));
        expertReviewOrders.unshift(...basketProofreadingOrders.filter(o => (o.isProcessingPayment || o.isUnpaidAndAfterOneMonthAgo) && o.hasExpertReview));
        plagiarismOrders.unshift(...basketPlagiarismOrders.filter(o => o.isProcessingPayment || o.isUnpaidAndAfterOneMonthAgo));
        aiProofreaderOrders.unshift(...basketAiProofreaderOrders.filter(o => o.isProcessingPayment || o.isUnpaidAndAfterOneMonthAgo));

        return {
            student,
            plagiarismOrders,
            freemiumOrders,
            proofreadingOrders,
            basketPlagiarismOrders,
            basketProofreadingOrders,
            aiProofreaderOrders,
            basketAiProofreaderOrders,
            expertReviewOrders,
            discounts,
        };
    },
});
